import React, { useEffect } from 'react';
import { CheckCircle2, AlertTriangle, AlertCircle, Info, X } from 'lucide-react';

export default function Toast({ toast, onClose }) {
  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => {
      onClose();
    }, toast.duration || 4000);
    return () => clearTimeout(timer);
  }, [toast, onClose]);

  if (!toast) return null;

  const icons = {
    success: <CheckCircle2 size={16} className="text-emerald-400 shrink-0" />,
    warning: <AlertTriangle size={16} className="text-amber-400 shrink-0" />,
    error: <AlertCircle size={16} className="text-red-400 shrink-0" />,
    info: <Info size={16} className="text-blue-400 shrink-0" />
  };

  const bgStyles = {
    success: 'border-emerald-500/30 bg-[#16221c]/95',
    warning: 'border-amber-500/30 bg-[#241d14]/95',
    error: 'border-red-500/30 bg-[#261517]/95',
    info: 'border-blue-500/30 bg-[#161c28]/95'
  };

  const type = toast.type || 'info';

  return (
    <div className="fixed bottom-12 right-6 z-50 max-w-sm animate-fade-in select-none">
      <div
        className={`flex items-start gap-3 p-3 rounded-xl border backdrop-blur-xl shadow-2xl text-xs text-zinc-200 ${
          bgStyles[type] || bgStyles.info
        }`}
      >
        {icons[type] || icons.info}
        <div className="flex-1 pr-2">
          {toast.title && <div className="font-semibold text-zinc-100 mb-0.5">{toast.title}</div>}
          <div className="text-zinc-300 leading-snug">{toast.message}</div>
        </div>
        <button
          onClick={onClose}
          className="text-zinc-500 hover:text-zinc-300 p-0.5 rounded transition"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
